import Icon, { type IconNames } from '@cobliteam/ui/icons';
import { cn } from '@cobliteam/ui/utils';

interface SmallFaceImageProps {
  variant?: 'placeholder' | 'image' | 'default';
  src?: string;
}

type SmallFaceVariants = Exclude<SmallFaceImageProps['variant'], undefined>;

const variants: Record<SmallFaceVariants, string> = {
  image: 'border-white',
  placeholder: 'border-dashed text-primary-7',
  default: 'text-primary',
};

const icons: Record<SmallFaceVariants, IconNames | undefined> = {
  image: undefined,
  default: 'scan-face',
  placeholder: 'plus',
};

const SmallFaceImage = ({ variant = 'image', src }: SmallFaceImageProps) => {
  const variantClass = variants[variant];
  const icon = icons[variant];

  return (
    <div className={cn('[&:not(:first-child)]:-ml-2 flex size-8 items-center justify-center overflow-hidden rounded-full border border-primary-7 bg-primary-2', variantClass)}>
      {icon && <Icon name={icon} />}
      {src && <img className='aspect-square size-full rounded-full bg-gray-4 object-contain' src={src} alt='' />}
    </div>
  );
};

export default SmallFaceImage;
